import { useState, useEffect, useRef } from "react";

const OtpTimer = ({ expirationTime, setNeedResend, resendText }) => {
  const endTimeRef = useRef(Date.now() + expirationTime * 1000);

  const calcRemaining = () => {
    const diffMs = endTimeRef.current - Date.now();
    return Math.max(0, Math.floor(diffMs / 1000));
  };

  const [remainingTime, setRemainingTime] = useState(calcRemaining);

  useEffect(() => {
    endTimeRef.current = Date.now() + expirationTime * 1000;
    setRemainingTime(calcRemaining());
    setNeedResend(false);
  }, [expirationTime, setNeedResend]);

  useEffect(() => {
    const interval = setInterval(() => {
      const secs = calcRemaining();
      setRemainingTime(secs);

      if (secs <= 0) {
        clearInterval(interval);
        setNeedResend(true);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [setNeedResend]);

  useEffect(() => {
    const syncOnVisibility = () => {
      const secs = calcRemaining();
      setRemainingTime(secs);
      if (secs <= 0) setNeedResend(true);
    };

    document.addEventListener("visibilitychange", syncOnVisibility);
    window.addEventListener("focus", syncOnVisibility);

    return () => {
      document.removeEventListener("visibilitychange", syncOnVisibility);
      window.removeEventListener("focus", syncOnVisibility);
    };
  }, [setNeedResend]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`;
  };

  return (
    <div
      style={{
        fontSize: "16px",
        fontWeight: 400,
        textAlign: "center",
      }}
    >
      {resendText}{" "}
      <span style={{ fontWeight: 700 }}>{formatTime(remainingTime)}</span>
    </div>
  );
};

export default OtpTimer;
